/* eslint-disable no-nested-ternary */
/* eslint-disable react/no-children-prop */
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';
import {
  Carousel, StatGraph, OptionButton, InvestmentPortfolioGraph,
} from 'components';
import { delayTime } from 'shared/constants';
// import classNames from 'classnames';
import './CarouselOption.scss';

const CarouselOptionContainer = ({
  children, label, id, name, onOptionClick, selected,
}) => (
  <section className="carousel-option__container">
    { children }
    <OptionButton
      label={label}
      onOptionClick={onOptionClick}
      id={id}
      name={name}
      selected={selected}
    />
  </section>
);

const CarouselOption = ({
  optionList,
  rtl,
  onOptionClick,
  isStatGraphOption,
  isInvestmentPortfolio,
  intl,
  children,
}) => {
  const [selectedOption, setSelectedOption] = useState(null);

  const statGraph = [
    { loss: '5', gain: '10' },
    { loss: '11', gain: '18' },
    { loss: '17', gain: '26' },
    { loss: '23', gain: '34' },
    { loss: '29', gain: '42' },
  ];

  const investmentPortfolio = [
    { best: '13,000', most: '4,000', worst: '-11,000' },
    { best: '18,000', most: '5,000', worst: '-15,000' },
    { best: '24,000', most: '6,500', worst: '-20,000' },
    { best: '30,000', most: '7,500', worst: '-25,000' },
    { best: '37,000', most: '8,500', worst: '-29,000' },
  ];

  // useEffect(() => {
  //   setTimeout(() => onOptionClick(selectedOption), delayTime);
  // }, [onOptionClick, selectedOption, delayTime]);

  return (
    <>
      <Carousel rtl={rtl} isCenterMode variableWidth className="carousel-option">
        {
          optionList && optionList.map((option, idx) => (
            <CarouselOptionContainer
              key={option.payload}
              children={isStatGraphOption ? <StatGraph lossLabel="risk.loss" gainLabel="risk.gain" loss={statGraph[idx].loss} gain={statGraph[idx].gain} /> : isInvestmentPortfolio ? <InvestmentPortfolioGraph bestCase={investmentPortfolio[idx].best} mostLikely={investmentPortfolio[idx].most} worstCase={investmentPortfolio[idx].worst} /> : children}
              label={`${intl.formatMessage({ id: 'risk.scenario' })} ${idx + 1}`}
              onOptionClick={() => {
                setSelectedOption(option.payload);
                setTimeout(() => onOptionClick(option.payload), delayTime);
              }}
              id={option.payload}
              name="riskQuestion"
              selected={selectedOption}
            />
          ))
        }
      </Carousel>
    </>
  );
};

CarouselOption.propTypes = {
  /** Option list */
  optionList: PropTypes.arrayOf(PropTypes.object),
  /** onSubmit function */
  onOptionClick: PropTypes.func,
  /** is option a stat graph? */
  isStatGraphOption: PropTypes.bool,
  /** is option an investment portfolio? */
  isInvestmentPortfolio: PropTypes.bool,
  /** isRTL */
  rtl: PropTypes.bool,
  /** carousel inside element/ content/ option */
  children: PropTypes.node,
};

CarouselOption.defaultProps = {
  optionList: [],
  onSubmit: () => {},
  isStatGraphOption: false,
  isInvestmentPortfolio: false,
  rtl: false,
  children: null,
};

export default injectIntl(CarouselOption);
